import { EventEmitter } from '@angular/core';
import { Influencer } from '../../../../models/influencer';
import { Router, ActivatedRoute } from '@angular/router';
import { NumberUtils } from '../../../utils/number.utils';
import { CommonConstant, listOrderedPlatforms } from '../../../app.constants';
import { UserService } from '../../../services/user.service';
import { ActionSource, ActivePages, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { CacheService } from '../../../services/cache/cache.service';
import { PercentNumberSuffixPipe } from '../../../pipes/custom-number-format.pipe';
var InfluencerItemComponent = /** @class */ (function () {
    function InfluencerItemComponent(router, userService, cacheService, activatedRoute) {
        this.router = router;
        this.userService = userService;
        this.cacheService = cacheService;
        this.activatedRoute = activatedRoute;
        this.isCampaignInfluencer = false;
        this.eventSelectInfluencer = new EventEmitter();
        this.deleteInfluencerEvent = new EventEmitter();
        this.approveInfluencerEvent = new EventEmitter();
        this.rejectSuggestedInfluencer = new EventEmitter();
        this.platformList = [];
        this.platformList = listOrderedPlatforms;
    }
    InfluencerItemComponent.prototype.onSelectInfluencer = function (influencer, e) {
        this.eventSelectInfluencer.emit(influencer);
    };
    InfluencerItemComponent.prototype.normalizeNumberData = function (value) {
        return NumberUtils.normalizeNumberToString(value);
    };
    InfluencerItemComponent.prototype.rejectInfluencer = function (e) {
        this.rejectSuggestedInfluencer.emit(this.influencer);
        e.preventDefault();
        e.stopPropagation();
    };
    InfluencerItemComponent.prototype.deleteInfluencer = function (e) {
        this.deleteInfluencerEvent.emit([this.influencer]);
        e.preventDefault();
        e.stopPropagation();
    };
    InfluencerItemComponent.prototype.approveInfluencer = function () {
        this.approveInfluencerEvent.emit(this.influencer);
    };
    InfluencerItemComponent.prototype.hasPlatform = function (platformName, influencer) {
        if (!influencer || !influencer.platform) {
            return false;
        }
        return influencer.platform.toLowerCase().indexOf(platformName.toLowerCase()) >= 0;
    };
    Object.defineProperty(InfluencerItemComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    InfluencerItemComponent.prototype.getCountryCode = function (influencer) {
        return influencer && influencer.country_code ? influencer.country_code : CommonConstant.INTERNATION_COUNTRY_CODE;
    };
    Object.defineProperty(InfluencerItemComponent.prototype, "influencerLanguage", {
        get: function () {
            if (!this.influencer || !this.influencer.language) {
                return null;
            }
            return this.influencer.language.name;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerItemComponent.prototype.goToInfluencerDetails = function (influencerId) {
        this.cacheService.disableCacheRemoving();
        if (this.isCampaignInfluencer) {
            this.router.navigate(["/influencer/" + influencerId + "/campaign"], {
                queryParams: {
                    activeAccount: this.activeAccount,
                    from_path: this.router.url.split('?')[0],
                    campaignInfluencerId: this.influencer.campaign_influencer_id,
                    selectedCampaign: this.campaignId
                }
            });
        }
        else {
            this.router.navigate(["/influencer/" + influencerId + "/overview"], { queryParams: { group_id: this.influencerGroupId, activeAccount: this.activeAccount } });
        }
    };
    Object.defineProperty(InfluencerItemComponent.prototype, "eventDataForDeleteAction", {
        get: function () {
            return {
                target: {
                    id: this.influencer && this.influencer.influencer_id || '*',
                    name: this.influencer && this.influencer.influencer_name || 'all',
                    type: TargetType.INFLUENCER
                },
                params: {
                    action: UserActionType.DELETE,
                    source: ActionSource.PAGE
                },
                activePage: {
                    type: ActivePages.GROUP_DETAILS,
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerItemComponent.prototype, "showLoader", {
        get: function () {
            return this.isLoadingData && this.influencer.isNewAdded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerItemComponent.prototype, "postValue", {
        get: function () {
            return this.influencer.isFailedUpdate ? '-' : this.normalizeNumberData(this.influencer.numberOfPosts);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerItemComponent.prototype, "reachValue", {
        get: function () {
            return this.influencer.isFailedUpdate ? '-' : this.normalizeNumberData(this.influencer.reach);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerItemComponent.prototype, "impactValue", {
        get: function () {
            var percentNumberSuffixTransform = new PercentNumberSuffixPipe();
            var impactNo = this.normalizeNumberData(this.influencer.impact);
            return this.influencer.isFailedUpdate ? '-' : percentNumberSuffixTransform.transform(Number(impactNo));
        },
        enumerable: true,
        configurable: true
    });
    return InfluencerItemComponent;
}());
export { InfluencerItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/influencer-item/influencer-item.component.ts.pre-build-optimizer.js